
/**
 * Module dependencies.
 */

import { availableFiltersKeys } from 'src/core/collections-config/filters';
import {
  trafficLevel,
  trafficLevelIcons
} from 'src/core/collections-config/traffic-level';

import { useFiltersList } from 'src/context/filters-list/context';
import { useTranslate } from 'src/core/utils/translator';
import FilterDisclosure from 'src/components/filters/filter-disclosure';
import FilterItem from 'src/components/filters/filter-item';
import FilterItemLabel from 'src/components/filters/filter-item-label';
import React, { ReactElement } from 'react';
import keys from 'lodash/keys';
import split from 'lodash/split';

/**
 * Filter name.
 */

const filterName = availableFiltersKeys.trafficLevel;

/**
 * `TrafficLevelFilter` component.
 */

const TrafficLevelFilter = (): ReactElement => {
  const { translate } = useTranslate();
  const { filters } = useFiltersList();
  const hasFilter = keys(filters).includes(filterName);
  const selectedFilters = hasFilter ? split(filters[filterName], ',').map(level => {
    return translate(`collections:trafficLevel.${level}`);
  }) : [];

  return (
    <FilterDisclosure
      name={filterName}
      selectedFilters={selectedFilters}
      title={translate('collections:labels.trafficLevel')}
    >
      {Object.values(trafficLevel).map((level: string) => (
        <FilterItem
          key={level}
          label={(
            <FilterItemLabel
              title={translate(`collections:trafficLevel.${level}`)}
              type={'icon'}
              value={trafficLevelIcons[level]}
            />
          )}
          name={filterName}
          value={level}
        />
      ))}
    </FilterDisclosure>
  );
};

/**
 * Export `TrafficLevelFilter` component.
 */

export default TrafficLevelFilter;
